<span class="calling-trends-title">
  <span class="mat-headline-6 activity-card-title">Inbound and outbound calling trends</span>
  <button mat-icon-button color="primary" [routerLink]="views.ADMIN_REPORTS">
    <mat-icon>chevron_right</mat-icon>
  </button>
</span>
<onsip-loading-container [deferCond]="loadingStateComplete$">
  @if (!noData) {
  <div class="calling-trends-container">
    <div class="graphics-container">
      <onsip-highcharts-line-graph
        [data]="trendData"
        [graphWidth]="lineGraphWidth"
      ></onsip-highcharts-line-graph>
    </div>
    <mat-divider class="divider"></mat-divider>
    <div class="summary-container">
      <div class="summary">
        <div class="summary-stat mat-headline-5">{{ avgInboundCalls }}</div>
        <div class="mat-caption">AVERAGE INBOUND CALLS PER DAY</div>
      </div>
      <div class="summary">
        <div class="summary-stat mat-headline-5">{{ avgOutboundCalls }}</div>
        <div class="mat-caption">AVERAGE OUTBOUND CALLS PER DAY</div>
      </div>
      <!--Uncomment when adding in calling credits-->
      <!-- <div class="summary">
      <div class="summary-stat mat-headline-5">{{ callingCreditsUsed }}</div>
      <div class="mat-caption">CALLING CREDITS USED</div>
    </div> -->
    </div>
  </div>
  } @else {
  <div class="empty-state">
    <img
      class="empty-state-img"
      [src]="'resources/img/inbound-outbound-trends-empty-state.svg'"
      alt="inbound-outbound-empty-state"
    />
    <span class="mat-body-1">there are no inbound and outbound calling trends yet</span>
  </div>
  }
</onsip-loading-container>
